import { CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";

import {
    svgBackCurvedArrow,
    SvgIconComponent,
    SvgRegistryService,
} from "@hermes/aphrodite-svg";

import { BackToHomeButtonComponent } from "./components/back-to-home-button/back-to-home-button.component";

@NgModule({
    imports: [CommonModule, SvgIconComponent, BackToHomeButtonComponent],
    exports: [BackToHomeButtonComponent],
})
export class BackToHomeButtonModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([svgBackCurvedArrow]);
    }
}
